<template>
  <div id="wrapper">
    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <h3 class="font-light m-b-xs">
            More about Edison Program
          </h3>
        </div>
      </div>
    </div>

    <div class="content">

      <div class="row" >
        <div class="col-lg-12">
          <div class="hpanel">
            <div class="panel-body info">

              <h3 class="font-bold text-center">The Edison Program certifies top experts in Digital, Supply Chain, Technical
                (R&D) and Solution & System Architect
              </h3>
              <p class="text-left m-b m-t-xxl">
                <strong> This Program recognizes expertise across Schneider Electric, that serves the
                  company strategy in four unique fields:
                </strong>
              </p>
              <div class="m-t-md">
                <ol class="m-b-lg list-group text-justify">
                  <li class="m-b-sm list-group-item-2"><strong>Edison Technical (R&D)</strong> - Designed for all employees who have a
                    technical expertise, its purpose is to boost Schneider’s Technology
                    strategy and R&D efficiency.</li>

                  <li class="m-b-sm list-group-item-2"><strong>Edison Supply Chain</strong> - Enables the growth and development of our
                    experts in the field of Supply Chain, recognizing their contribution and
                    impact towards our business priorities and agenda.</li>

                  <li class="m-b-sm list-group-item-2"><strong>Edison Digital</strong> - Leverages the Information Technology expertise to
                    serve Schneider Digital strategy and offers attractive career paths to
                    Schneider Electric employees specialized in Digital competencies.</li>

                  <li class="m-b-sm list-group-item-2"><strong>Solution & System Architect Edison Program</strong> - Identifies, develops and
                    recognizes Schneider's experts in charge of developing innovative and
                    differentiating solutions that meet customers specific needs in our
                    targeted segments.
                  </li>
                </ol>
              </div>
              <p class="text-left m-b m-t-xxl">
                <strong> The Edison Expert:</strong>
              </p>
              <div class="m-t-md">
                <ul class="m-b-lg" style="list-style-type: lower-alpha;">
                  <li class="m-b-sm">masters a specific field of expertise,</li>
                  <li class="m-b-sm">demonstrates strategic thinking and puts the customer first,</li>
                  <li class="m-b-sm">applies technical skills and knowledge to drive innovation, </li>
                  <li class="m-b-sm">develops and shares his/her knowledge and know-how.</li>
                </ul>
                <p>  The Edison certification is renewed every 3 years.</p>
              </div>

              <div class="row text-center m-t">
                <router-link :to="{name:'SearchSimple'}" class="btn btn-info"><i class="fa fa-search"> </i> Back to LEA Simple Search </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="hpanel plan-box hblue active">
            <div class="panel-body">
              <p>
                <strong> <u>Know More section: </u></strong>
              </p>
              <ul style="list-style-type: none;">
                <li class="m-b-sm">- <a href="http://isee.schneider-electric.com/isee/EDISON_Technical_Program" target="_blank" class="text-info m-t-s"> Edison Technical (R&D) Application Process</a></li>
                <li class="m-b-sm">- <a href="http://isee.schneider-electric.com/wiki/index.php?curid=8095&action=view" target="_blank" class="text-info m-t-s"> Edison Supply Chain Application Process in ISEE</a></li>
                <li class="m-b-sm">- <a href="http://isee.schneider-electric.com/isee/EDISON_DIGITAL_Program" target="_blank" class="text-info m-t-s"> Edison Digital Application Process</a></li>
                <li class="m-b-sm">- <a href="http://isee.schneider-electric.com/isee/EDISON_Programs" target="_blank" class="text-info m-t-s"> Edison Solution & System Architect Application Process</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .list-group-item-2 {
    display: list-item;
    margin-left: 40px;
  }
</style>

<script>
export default {
  name: 'AboutEdison',
  components: {},
  data () {
    return {
      api_url: process.env.API_URL,
      website_url: process.env.WEBSITE_URL,
      show_video: false,
      video_url: 'https://schneider-electric.box.com/s/1qy85yoj5nv3ffaep2ginzzvg8hg4nyx'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/AboutEdison.vue